module.exports = __webpack_public_path__ + "static/media/staff.54482f0a.svg";